<template>
  <div :class="['dashboard-object-tree', disabled ? 'disabled' : '']">
    <div class="search">
      <w-search-field ref="searchField" size="mini" @search="filterTree"/>
    </div>
    <el-scrollbar class="dashboard-object-tree__wrapper">
      <el-tree class="tree-checkbox"
        :default-expanded-keys="['1']"
        :ref= "TREE_CONST.REF"
        :data="treeData"
        :props="defaultProps"
        :node-key="defaultProps.treeKey"
        :highlight-current="!isMultiple"
        :show-checkbox="isMultiple"
        :filter-node-method="filterNode"
        :expand-on-click-node="false"
        v-on="isMultiple ? {'check-change': onCheckChange} : {'node-click': onNodeClick }"
      >
        <span class="el-tree-node__label" slot-scope="{ node, data }">
          <label :title="objNodeLabel(data)">{{objNodeLabel(data)}}</label>
        </span>
      </el-tree>
    </el-scrollbar>
  </div>
</template>

<script>
import axios from 'axios';
import TreeAPI from '@/api/common/tree';
import WidgetAPI from '@/api/dashboard/widget';
import LogicalGroupApi from '@/api/settings/common/logical-group';

import { defaultProps } from '@/constants/tree';
import DashboardConst from '@/constants/dashboard';
import { isEmpty } from '@/utils/basic';
import { getPathNodes, isObjNode, isRequireIPObjType, getObjNodeLabel } from '@/utils/tree';
import WSearchField from '@/components/form/SearchField';

const TREE_CONST = DashboardConst.TREE_CONST;

export default {
  name: 'WObjSelectTree',
  components: {
    WSearchField,
  },
  props: {
    /**
     * [전체선택일 경우 트리 disalble 처리 여부]
     * @type {Boolean}
     */
    disabled: {
      type: Boolean,
      default: false,
    },
    /**
     * [트리 타입 : check인지 single인지 ]
     * @type {String}
     */
    isMultiple: {
      type: Boolean,
      default: false,
    },
    /**
     * [트리 기존 설정 노드]
     * @type {Object}
     */
    selecetedNode: {
      type: [Object, Array],
      default: () => {},
    },
    selectScope: {
      type: String,
      default: TREE_CONST.SELECT_SCOPE.DEFAULT,
    },
    treeDataType: {
      type: String,
      default: 'node',
    },
  },
  data() {
    return {
      TREE_CONST,
      isEmpty,
      defaultProps,
      treeData: [],
      allManagetypeTreeData: [],
      physicalTreeData: [],
      e2eTreeData: [],
      treeKeyList: [],
      /**
       * [관리대상 트리에서 기본으로 필터링 되어야하는 관리구분]
       * @type {[type]}
       */
      defaultFilterValue: {
        managetypeId: 'SMS',
        managetypeKey: '_',
      },
      originalSelectedInfo: {
        managetypeId: '',
        managetypeKey: '',
      },
    };
  },
  computed: {
    treeRef() {
      return this.$refs[TREE_CONST.REF];
    },
  },
  watch: {
    treeData: {
      immediate: true,
      handler(val) {
        if (!isEmpty(val)) {
          this.$nextTick(() => {
            this.treeRef.filter();
          });
        }
      },
    },
  },
  methods: {
    loadData(isPredict) {
      if (this.treeDataType === 'node') {
        axios.all([
          TreeAPI.getLogicalTreeData({ onlyPredictTarget: isPredict }),
          WidgetAPI.getEmsPhysicalTreeData({ managetypeId: 'EMS' }),
          WidgetAPI.getE2ELogicalTreeData({ onlyPredictTarget: isPredict }),
        ]).then(axios.spread((allManagetypeTreeDataRes, physicalTreeDataRes, e2eTreeDataRes) => {
          if (!isEmpty(allManagetypeTreeDataRes.data) && allManagetypeTreeDataRes.data.success) {
            this.allManagetypeTreeData = [allManagetypeTreeDataRes.data.children];
            this.treeData = [allManagetypeTreeDataRes.data.children];
          }
          if (!isEmpty(physicalTreeDataRes.data) && physicalTreeDataRes.data.success) {
            this.physicalTreeData = [physicalTreeDataRes.data.children];
          }
          if (!isEmpty(e2eTreeDataRes.data) && e2eTreeDataRes.data.success) {
            this.e2eTreeData = [e2eTreeDataRes.data.children];
          }
          this.$nextTick(() => {
            this.setTreeData();
          });
        }));
      } else if (this.treeDataType === 'group') {
        LogicalGroupApi.getLogicalGroupTree().then((res) => {
          if (!isEmpty(res.data) && res.data.success) {
            this.treeData = res.data.data;
          }
          this.$nextTick(() => {
            this.expandNodeByTreeKey(this.treeKeyList);
            if (this.isMultiple) {
              this.treeRef.setCheckedKeys(this.treeKeyList);
            } else {
              this.treeRef.setCurrentKey(this.treeKeyList[0]);
            }
          });
        });
      }
    },
    objNodeLabel(data) {
      return isObjNode(data) && isRequireIPObjType(data) ? getObjNodeLabel(data) : data.label;
    },
    filterTree(keyword) {
      if (this.treeRef) {
        this.treeRef.filter(keyword);
      }
    },
    filterNode(value, data) {
      if (this.treeDataType === 'node') {
        const dfValue = this.defaultFilterValue;
        if (isEmpty(value)) {
          if (isEmpty(dfValue)) {
            return true;
          }
          if (dfValue.managetypeKey !== '_') {
            if (dfValue.managetypeId === 'VMS' || dfValue.managetypeId === 'DBMS') {
              return ((dfValue.managetypeId === 'VMS') ? (data.obj && data.obj.objManagetypeId === dfValue.managetypeId && data.obj.objtypeId === dfValue.managetypeKey) : (data.obj && data.obj.objManagetypeId === dfValue.managetypeId && data.obj.objtypeId === DashboardConst.OBJTYPE[dfValue.managetypeKey]));
            }
            if (dfValue.managetypeId === 'NMS' && dfValue.managetypeKey === 'ND') {
              return (data.obj && data.obj.objManagetypeId === dfValue.managetypeId && (data.obj.objDefineId === DashboardConst.OBJDEFINE.ND || data.obj.objDefineId === DashboardConst.OBJDEFINE.WD));
            }
            return ((data.obj && data.obj.objManagetypeId === dfValue.managetypeId && data.obj.objDefineId === DashboardConst.OBJDEFINE[dfValue.managetypeKey]));
          } else if (dfValue.managetypeKey === '_' && dfValue.managetypeId === 'E2E') {
            return true;
          }
          return (data.obj && data.obj.objManagetypeId === dfValue.managetypeId);
        } else if (!isEmpty(value)) {
          if (isEmpty(data.ipaddress)) {
            return ((dfValue.managetypeId === 'VMS') ? (data.obj && data.obj.objManagetypeId === dfValue.managetypeId && data.obj.objtypeId === dfValue.managetypeKey) : (data.obj && data.obj.objManagetypeId === dfValue.managetypeId)) && (data.label.toLowerCase().indexOf(value.toLowerCase()) !== -1);
          }
          // IP 정보가 있는 경우 IP도 함께 검색한다.
          const keyword = value.toLowerCase();
          return ((dfValue.managetypeId === 'VMS') ? (data.obj && data.obj.objManagetypeId === dfValue.managetypeId && data.obj.objtypeId === dfValue.managetypeKey) : (data.obj && data.obj.objManagetypeId === dfValue.managetypeId)) && (data.label.toLowerCase().indexOf(keyword) !== -1 || (!isEmpty(data.ipaddress) && data.ipaddress.toLowerCase().indexOf(keyword) !== -1));
        }
      } else if (this.treeDataType === 'group') {
        if (isEmpty(value)) {
          return true;
        }
        return (data.label.toLowerCase().indexOf(value.toLowerCase()) !== -1);
      }
      return true;
    },
    initTreeData() {
      this.treeData = [];
    },
    setDefaultNodeByTreeKey(newNodeTreeKeyList, originalSelectedInfo) {
      this.treeKeyList = newNodeTreeKeyList;
      this.originalSelectedInfo = originalSelectedInfo;
    },
    getCurrentNode() {
      if (this.isMultiple) {
        const currentCheckdNode = this.treeRef.getFilteredCheckedNodes();
        return currentCheckdNode.reduce((accumulator, value) => {
          if ((this.selectScope === TREE_CONST.SELECT_SCOPE.LEAF && isEmpty(value.children)) || this.selectScope === TREE_CONST.SELECT_SCOPE.ALL) {
            accumulator.nodes.push(value);
            accumulator.treeKeys.push(value.treeKey);
          }
          return accumulator;
        }, { nodes: [], treeKeys: [] });
      }
      const currentNode = this.treeRef.getCurrentNode();
      // if (!isEmpty(currentNode) && isEmpty(currentNode.children)) {
      if (!isEmpty(currentNode)) {
        return {
          nodes: [this.treeRef.getCurrentNode()],
          treeKeys: [this.treeRef.getCurrentNode().treeKey],
        };
      }
      return {
        nodes: [],
        treeKeys: [],
      };
    },
    setTreeData(filterValue) {
      if (!isEmpty(filterValue)) {
        this.defaultFilterValue = filterValue;
      }
      const { managetypeId, managetypeKey } = this.defaultFilterValue;
      this.$nextTick(() => {
        if (managetypeId === 'E2E') {
          this.treeData = this.e2eTreeData;
        } else if (managetypeId === 'EMS') {
          this.treeData = this.physicalTreeData;
        } else {
          this.treeData = this.allManagetypeTreeData;
        }
        this.$nextTick(() => {
          // this.treeRef.filter();

          /**
           * 속도 개선을 위한 expandNodeByTreeKey 주석
           * 이로인해 1depth까지만 펼쳐진다.
           */
          // this.expandNodeByTreeKey(this.treeKeyList);
          if (this.originalSelectedInfo.managetypeId === managetypeId && this.originalSelectedInfo.managetypeKey === managetypeKey) {
            if (this.isMultiple) {
              this.treeKeyList.forEach((value) => {
                setTimeout(() => {
                  this.treeRef.setChecked(value, true);
                }, 5);
              });
            }
            /**
             * 속도 개선을 위한 주석 setCheckedKeys
             * 위와 같이 keyList에 대해 for문으로 Thread를 수행하면서 check 해주는 것이 속도상 이득이다.
             * 장비 2000대 선택 기준 setCheckedKeys: 50초, forEach + setChecked: 5초
             */
            // this.treeRef.setCheckedKeys(this.treeKeyList);
          } else {
            // this.treeRef.setCurrentKey(this.treeKeyList[0]);
            this.treeRef.setCurrentKey(this.treeKeyList[0]);
          }
          // this.$nextTick(() => {
          // });
        });
      });
    },
    // setTreeData(newTreeData) {
    //   this.treeData = newTreeData;
    // },
    setFilter(newFilterValue) {
      this.treeRef.filter(newFilterValue);
    },
    getTreeKeysInObjList(objList) {
      return objList.map((objNode) => objNode.treeKey);
    },
    expandNodeByTreeKey(treeKeys) {
      if (isEmpty(treeKeys)) {
        return;
      }
      treeKeys.forEach((treeKey) => {
        const node = this.treeRef.getNode(treeKey);
        const path = getPathNodes(node);
        path.forEach((item) => {
          if (!item.isLeaf) item.expanded = true;
        });
      });
    },
    onCheckChange() {
      this.$emit('update:selectedNode', this.getCurrentNode());
      // this.$emit('update:selectedNode', this.getCurrentNode().treeKeys);
    },
    onNodeClick(clickedNode) {
      const nodes = clickedNode.children ? [] : [clickedNode];
      const treeKeys = clickedNode.children ? [] : [clickedNode.treeKey];
      const resultNode = {
        nodes,
        treeKeys,
      };
      // const resultNode = clickedNode.children ? [] : [clickedNode.treeKey];
      this.$emit('update:selectedNode', resultNode);
    },
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/views/dashboard/widgets/coord/setting/components/ObjSelectTree.vue